import { queryWithVariables } from '@/services/api/api';
import { featureFlagDefaultValue } from '@/stores/featureFlagStore';
import { FeatureFlag } from '@/types/api/FeatureFlag/FeatureFlag';

export const getFeatureFlags = async (): Promise<{
  key: keyof FeatureFlag
  value: boolean
}[]> => {

  const featureList = Object.keys(featureFlagDefaultValue)
  try {
    const result = await queryWithVariables(
      `
      query($featureList: [String!]!) {
        featureFlags(featureList: $featureList) {
          key
          value
        }
      }
    `, {
      featureList
    });
    return result.data?.featureFlags ?? []
  } catch (error) {
    console.error('Failed to fetch feature flags', error);
    return [];
  }
};
